import { Injectable } from '@angular/core';
import { AlertController, ToastController,LoadingController } from '@ionic/angular';
import { callbackify } from 'util';

@Injectable({
  providedIn: 'root'
})
export class ServicioLoadersAlertasService {

  constructor( public alertController: AlertController, public toast: ToastController, public loadingController: LoadingController) { }


  async presentLoading(mensaje) {
    const loading = await this.loadingController.create({
      message: mensaje,
    });
    await loading.present();
    const { role, data } = await loading.onDidDismiss();
    console.log('Loading dismissed!');
  }



  async alerta(entradaheader, entradamessage) {
    const alert = await this.alertController.create({
      header: entradaheader,
      message: entradamessage,
      buttons: [
        {
          text: 'OK',
          handler: () => {
         }
        }
      ]
    });
    await alert.present();
  }


  

  





  async presentToast(mensaje) {
    const toast = await this.toast.create({
      message: mensaje,
      duration: 4000
    });
    toast.present();
  }

  cerrarmodal(){
    console.log("cerrar modal llamado")
    this.loadingController.dismiss()
  }





}
